import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { CheckboxControlComponent } from '../../form/checkbox-control/checkbox-control.component';
import { SearchInputComponent } from '../../form/search-input/search-input.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SkeletonModule } from 'primeng/skeleton';
import { Observable, Subject, of, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { StateService } from '../../../../core/state/old/state.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { IShopParams } from '../../../../routes/shop/shop.component';
import { FilterCheckboxOptionsPipe } from './filter-checkbox-options.pipe';

@Component({
  selector: 'app-checkbox-options',
  standalone: true,
  imports: [CommonModule, CheckboxControlComponent, SearchInputComponent, AccordionModule, ScrollPanelModule, ProgressSpinnerModule, SkeletonModule,
    FilterCheckboxOptionsPipe
  ],
  templateUrl: './checkbox-options.component.html',
  styleUrl: './checkbox-options.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxOptionsComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribeGlobal$: Subject<void> = new Subject<void>();

  @Input() checkboxOptions: { value: string, label: string, count?: any }[] = [];
  @Input() searchEnabled: boolean = false;
  @Input() name!: string;
  @Input() filterControl!: FormControl | any;
  @Input() filterId!: any;
  @Input() loading$: Observable<boolean> = of(false);
  @Input() initialLoading!: boolean;




  public searchControl: FormControl = new FormControl(undefined);
  public filterOptionsFormGroup: FormGroup;

  constructor(private fb: FormBuilder, private stateService: StateService, private router: Router, private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    if(!environment.websiteSettings.enableLeftFiltersCountChange){
      if (Array.isArray(this.filterControl.value)) {
        this.setInitialValues(this.filterControl.value as string[]);
      }
    }
    if (this.loading$) {
      this.subscribeToLoadingChanges();
    }
  }

  private subscribeToLoadingChanges() {
    this.loading$.pipe(takeUntil(this.unsubscribeGlobal$)).subscribe(loading => {
      if (loading) {
        this.filterOptionsFormGroup.disable();
        this.searchControl?.disable();
      } else {
        this.filterOptionsFormGroup.enable();
        this.searchControl?.enable();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('checkboxOptions' in changes) {
      this.generateFilterOptionsGroup();
      this.cdr.markForCheck();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeGlobal$.next();
    this.unsubscribeGlobal$.complete();
  }

  public resetAllValues() {
    this.filterOptionsFormGroup.reset();
  }


  private generateFilterOptionsGroup() {
    const groupControls: { [key: string]: any } = {}; // Define an index signature for TypeScript
    this.checkboxOptions.forEach(option => {
      groupControls[option.value] = [null]; // Set initial value as null for each option
    });
    this.filterOptionsFormGroup = this.fb.group(groupControls);

    if(environment.websiteSettings.enableLeftFiltersCountChange){
    if (Array.isArray(this.filterControl.value)) {
      this.setInitialValues(this.filterControl.value as string[]);
      }
    }

  }

  private setInitialValues(initialValues: string[]) {
    for (const key of Object.keys(this.filterOptionsFormGroup.controls)) {
      if (initialValues.includes(key)) {
        this.filterOptionsFormGroup.get(key)?.setValue([key]);
        
      }
    }
  }


  public onOptionsChange(event: CheckboxChangeEvent) {


    const formGroupValues: string[] = Object.values(this.filterOptionsFormGroup.getRawValue())
      .flatMap(value => Array.isArray(value) ? value.filter(item => item !== null) : (value !== null ? [value] : []));
      if(environment.websiteSettings.enableLeftFiltersCountChange){
        if(formGroupValues?.length == 0){

          this.router.navigate([], {
            relativeTo: this.route,
            queryParamsHandling: 'merge',
            queryParams: {lf: null } as IShopParams,
            state: {
              noScroll: true,
            },
          } as NavigationExtras).then(() => {
            this.filterControl.setValue(formGroupValues);
          });
        } else {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParamsHandling: 'merge',
          queryParams: {lf: this.filterId } as IShopParams,
          state: {
            noScroll: true,
          },
        } as NavigationExtras).then(() => {
          this.filterControl.setValue(formGroupValues);
        });
      }
      } else {
        this.filterControl.setValue(formGroupValues);
      }

  }
}
